import React, { useState, useEffect,useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LogoutModel from './LogoutModel';
import { toast } from 'react-toastify';
import {moduleAndLoginDivDisabled, setPrintMode, FetchPrintModeModalStatus } from '../ReduxState';
import { fncFocusElementDependsOnPathLocation, fncCheckIfTokenIsExpired } from '../Utility/CommonFun.js';
import { Button, Modal } from 'react-bootstrap';
import LocationQrScanner from '../Components/LocationQrScanner.js';
import { fncSitaFlexGetTokenOrStatus } from '../Utility/ApiCall.js'

function PeripheralDevices({handleSideMenu}) {
  const [showScanner, setShowScanner] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const   [tail,settail] =useState(false);
    const fullContainerRef = useRef(null);
    const okBtnPopupRef = useRef(null);
    const modalRef = useRef(null);
    const [triggerModal, settriggerModal] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const redirectTo = useSelector(state => state.sidemenu.redirectionPage);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
    const selectedprintMode = useSelector(state => state.printMode.selectedMode);
    const sitaFlexLocationId = useSelector(state => state.printMode.sitaFlexLocationId);
    const PrintModeModalStatus = useSelector(state => state.printMode.PrintModeModalStatus);
    const goBack = () => {
        console.log('goBack',redirectTo,  location.pathname)
        if (redirectTo === '/PeripheralDevices') {
            history.push('/Search')
        } else {
            history.push(redirectTo);
        }
    }

    const getPrinterName = (printerType) => {
        let name = '';
        const printers = JSON.parse(localStorage.getItem('Printers'));
        if (printerType === 'bt') {
                name = printers.bagTag ? printers.bagTag.name : ''
        }
        if (printerType === 'bp') {
                name = printers.boardingPass ? printers.boardingPass.name : ''
        }
        return name;
    }

    const [availablePrinters, setAvailablePrinters] = useState([]);
    const [availableBluetoothPrinters, setavailableBluetoothPrinters] = useState([]);
    const [clientInfo, setClientInfo] = useState('');
    const [lsprinters, setPrinters] = useState([]);
    const [bagtagPrinter, setbagtagPrinter] = useState(localStorage.getItem("Printers") ? getPrinterName('bt') : 'Select the Printer');
    const [boardingPrinter, setboardingPrinter] = useState(localStorage.getItem("Printers") ? getPrinterName('bp') :'Select the Printer');
    const [sitaFlexPrinter, setsitaFlexPrinter] = useState([]);
    const notify = (e) =>
    toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifySuccess = (e, close = 5000) =>
    toast.success(e, {
      position: "top-right",
      autoClose: close,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    useEffect(() => {
        console.log('selectedprintMode', selectedprintMode);
        if (selectedprintMode === 'Native') {
            var wlPort = (new URLSearchParams(window.location.search)).get('wlport');
        debugger
        if(wlPort == null) wlPort = 27443;
        // JSPM.JSPrintManager.getClientAppInfo().then((e) => {
        //   let jsonData = JSON.parse(e);
        //   let cInfo = "Version: " + jsonData.version + " OS: " + jsonData.os + " (" + jsonData.arch + ")";
        //   setClientInfo(jsonData.os); //Android
        //   console.log('cinfo', cInfo)
        // }).catch((e) => console.error(e))
        JSPM.JSPrintManager.license_url = process.env.REACT_APP_JSPM_LICENCE_URL;
        JSPM.JSPrintManager.auto_reconnect = true;
        JSPM.JSPrintManager.start(true, 'localhost', wlPort);
        console.log('JSPM.JSPrintManager.start(true, localhost, wlPort)', wlPort)
          
          
        JSPM.JSPrintManager.WS.onStatusChanged = function () {
          console.log('JSPM.JSPrintManager.WS',  JSPM.WSStatus.Open)
          if (jspmWSStatus()) {
            console.log('JSPM connected');
            console.log('local storage printerData', lsprinters);
            document.getElementById("showAndHideSpinner").style.display = "block";
            JSPM.JSPrintManager.getClientAppInfo().then((e) => {
                let jsonData = JSON.parse(e);
                let cInfo = "Version: " + jsonData.version + " OS: " + jsonData.os + " (" + jsonData.arch + ")";
                // setClientInfo(jsonData.os); //Android
                if (jsonData.os.includes('Android')) {
                    JSPM.JSPrintManager.getBluetoothDevices().then(function (bluetoothprinters) {
                        console.log('bluetooth printers', bluetoothprinters, bluetoothprinters.filter(bp => bp.authenticated && bp.remembered));
                        let bluetoothprinter = bluetoothprinters.length === 0 ? [] : bluetoothprinters; //bluetoothprinters.filter(bp => bp.authenticated && bp.remembered)
                        // const printerList = [...lsprinters, ...bluetoothprinter];
                        // JSPM.JSPrintManager.getPrintersInfo().then(function (installedprinters) {
                        //     let clientPrinters = [];
                        //     installedprinters.forEach((item) => {
                        //         if (!isVirtualPrinter(item)) {
                        //             clientPrinters.push(item);
                        //         }
                        //     })
                            console.log('bluetoothprinter', bluetoothprinter);
                            const installedprintersList = [...lsprinters, ...bluetoothprinter];
                            console.log('printersList', installedprintersList);
                            setPrinters(installedprintersList);
                            document.getElementById("showAndHideSpinner").style.display = "none";
                        // })
                      //   setavailableBluetoothPrinters(bluetoothprinters.filter(bp => bp.authenticated && bp.remembered))
                        
                        // setPrinters(printerList);
                      })
                } else {
                    JSPM.JSPrintManager.getBluetoothDevices().then(function (bluetoothprinters) {
                        console.log('bluetooth printers', bluetoothprinters.filter(bp => bp.authenticated && bp.remembered));
                        let bluetoothprinter = bluetoothprinters.length === 0 ? [] : bluetoothprinters.filter(bp => bp.authenticated && bp.remembered)
                        // const printerList = [...lsprinters, ...bluetoothprinter];
                        JSPM.JSPrintManager.getPrintersInfo().then(function (installedprinters) {
                            let clientPrinters = [];
                            installedprinters.forEach((item) => {
                                if (!isVirtualPrinter(item)) {
                                    clientPrinters.push(item);
                                }
                            })
                            console.log('installed printers', clientPrinters, installedprinters, bluetoothprinter);
                            const installedprintersList = [...lsprinters, ...clientPrinters, ...bluetoothprinter];
                            console.log('printersList', installedprintersList);
                            setPrinters(installedprintersList);
                            document.getElementById("showAndHideSpinner").style.display = "none";
                        })
                      //   setavailableBluetoothPrinters(bluetoothprinters.filter(bp => bp.authenticated && bp.remembered))
                        
                        // setPrinters(printerList);
                      })
                }
                console.log('cinfo', cInfo)
              }).catch((e) => console.error(e))
            // JSPM.JSPrintManager.getBluetoothDevices().then(function (bluetoothprinters) {
            //     console.log('bluetooth printers', bluetoothprinters.filter(bp => bp.authenticated && bp.remembered));
            //     let bluetoothprinter = bluetoothprinters.length === 0 ? [] : bluetoothprinters.filter(bp => bp.authenticated && bp.remembered)
            //     // const printerList = [...lsprinters, ...bluetoothprinter];
            //     JSPM.JSPrintManager.getPrintersInfo().then(function (installedprinters) {
            //         let clientPrinters = [];
            //         installedprinters.forEach((item) => {
            //             if (!isVirtualPrinter(item)) {
            //                 clientPrinters.push(item);
            //             }
            //         })
            //         console.log('installed printers', clientPrinters, installedprinters, bluetoothprinter);
            //         const installedprintersList = [...lsprinters, ...clientPrinters, ...bluetoothprinter];
            //         console.log('printersList', installedprintersList);
            //         setPrinters(installedprintersList);
            //         document.getElementById("showAndHideSpinner").style.display = "none";
            //     })
            //   //   setavailableBluetoothPrinters(bluetoothprinters.filter(bp => bp.authenticated && bp.remembered))
                
            //     // setPrinters(printerList);
            //   })
            // JSPM.JSPrintManager.getBluetoothDevices().then(function (bluetoothprinters) {
            //   console.log('bluetooth printers', bluetoothprinters.filter(bp => bp.authenticated && bp.remembered));
            //   let bluetoothprinter = bluetoothprinters.filter(bp => bp.authenticated && bp.remembered)
            //   const printerList = [...lsprinters, ...bluetoothprinter];
            // //   setavailableBluetoothPrinters(bluetoothprinters.filter(bp => bp.authenticated && bp.remembered))

            //   setPrinters(printerList);
            // })
            // JSPM.JSPrintManager.getPrintersInfo().then(function (installedprinters) {
            //   //     var options = '';
            //   // availablePrinter = myPrinters;
            //   console.log('installed printers', installedprinters);
            // //   setAvailablePrinters(printers)
            // const installedprintersList = [...lsprinters, ...installedprinters];
            //   setPrinters(installedprintersList);
            //   document.getElementById("showAndHideSpinner").style.display = "none";
            // })
          } else {
            console.log('JSPM not connected');
            document.getElementById("showAndHideSpinner").style.display = "none";
          }
        }
        // Handle JSPM errors
        JSPM.JSPrintManager.WS.onError = (event) => {
          console.error('JSPM error:', event);
        };
    
        // Cleanup on unmount
        return () => {
          JSPM.JSPrintManager.stop();
        };
        }
        else if (selectedprintMode === 'SITA FLEX' && sitaFlexLocationId !== '') {
            debugger
            fncSitaFlexGetTokenOrStatus({
                LocationId: sitaFlexLocationId,
                Type: "RT" 
                })
                .then((response) => {
                    console.log('fncMBPDetails', response);
                    if (response.status == "401" && response.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                    } else {
                        if (response.status == 200) {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            console.log('returnVal.data', response.data);
                            setsitaFlexPrinter(response.data);
                            localStorage.setItem('SITAPrinters', JSON.stringify(response.data));
                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            const dummy = [ 

                                { 
                                
                               "deviceId": "A-JAF-JAF1WLB006.ATB1", 
                                
                                 "deviceStatus": "Online", 
                                
                                "mediaStatus": "Ok", 
                                
                                "binStatus": "Ok" 
                                
                                }, 
                                
                                { 
                                
                                 "deviceId": "A-JAF-JAF1WLB006.BTP1", 
                                
                                 "deviceStatus": "Online", 
                                
                                 "mediaStatus": "Ok", 
                                
                                 "binStatus": "Ok" 
                                
                                } 
                                
                                ]

                                setsitaFlexPrinter(dummy);
                                localStorage.setItem('SITAPrinters', JSON.stringify(dummy));
                            // if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            //   settriggerModal(true);
                            // } else {
                            //   notify(returnVal.data.errorDetail.errorMessage);
                            // }
                        }
                    }
                    
                  })
                  .catch((err) => {
                    console.log("Axios err in fncSitaFlexGetTokenOrStatus: ", err);
                    notify('Something went wrong. Please try again after sometime.', 3000);
                });
        }
        
    }, [])

    useEffect(() => { 
        const handleKeyDown = (e) => {
                if (e.altKey && e.key.toLowerCase() === 'c') {
                   if(!IsModulAndLoginDivDisabled){
                                           dispatch(moduleAndLoginDivDisabled({
                                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                                IsModulAndLoginDivDisabled: true
                                            }));
                        // fncFocusElementDependsOnPathLocation(location.pathname,document.getElementById('bagTagsSelect'));
                    }else if (IsModulAndLoginDivDisabled) {
                                                          const headingDiv = document.querySelector(".modulebtn");            
                                                          if (headingDiv) {                  
                                                              headingDiv.focus();
                                                              dispatch(moduleAndLoginDivDisabled({
                                                                      type: "MODULE_AND_LOGINDIV_DISABLED",
                                                                      IsModulAndLoginDivDisabled: false
                                                                  }));
                                                          }
                                                      }
                }
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => {
        document.removeEventListener("keydown", handleKeyDown);
        }; 
    },[IsModulAndLoginDivDisabled])

    useEffect(() => {
        //  debugger
        document.addEventListener("keydown", function (event) {  
            if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
            handleSideMenu();
            }
        })
    });

    function jspmWSStatus() {
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
            console.log('JSPrintManager (JSPM) is installed');
            return true;
        }
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
            console.log('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
            console.log('JSPM has blocked this website!');
            return false;
        }
    }

    function fncSelectBagtagPrinter(e) {
        console.log('fncSelectBagtagPrinter', e.target.value)
        
        if (boardingPrinter === e.target.value) {
            notify('Please select another printer as it is already selected for boarding pass printing')
        } else {
            
            setbagtagPrinter(e.target.value)
        }
        console.log(localStorage.getItem("Printers"))
        console.log(localStorage.getItem("LoginToken"))
    }

    function fncSelectBoardingPrinter(e) {
        console.log('fncSelectBoardingPrinter', e.target.value)
        if (bagtagPrinter === e.target.value) {
            notify('Please select another printer as it is already selected for bag tag printing')
        } else {
            setboardingPrinter(e.target.value);
        }
    }

    function fncSetPrintersToLocalStorage() {
        console.log('fncSetPrintersToLocalStorage', bagtagPrinter, boardingPrinter)
        // if (bagtagPrinter === 'Select the Printer' || boardingPrinter === 'Select the Printer') {
        //     notify('Please select both the printers first.')
        // } else {
            const btPrinter = lsprinters.find(p => p.name === bagtagPrinter);
            const bpPrinter = lsprinters.find(p => p.name === boardingPrinter);
            console.log('bt and bp', btPrinter, bpPrinter);
            localStorage.setItem('Printers', JSON.stringify({bagTag: btPrinter ? btPrinter : null, boardingPass: bpPrinter ? bpPrinter : null}));
            notifySuccess('Successfully selected printers');
            history.push(redirectTo);
        // }
    }

    function resetPrintersOnlocalStorage() {
        // console.log('resetPrintersOnlocalStorage----',localStorage.getItem("Printers"));
        localStorage.removeItem("Printers");
        setbagtagPrinter('Select the Printer')
        setboardingPrinter('Select the Printer')
    }

    //Guessing whether a printer is Virtual or real/physical
    function isVirtualPrinter(clientPrinter) {
        let printerPort = clientPrinter.port ? clientPrinter.port.toLowerCase() : '';
        //For Windows
        if (printerPort != "nul" && clientPrinter.BIDIEnabled) return false;
        //For Unix
        if (printerPort.indexOf("usb") >= 0 && printerPort.indexOf("?serial=") >= 0) return false;
            
        return true;
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
            goBack();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
        document.removeEventListener("keydown", handleKeyDown);
        };
    }, [redirectTo]);

    const handleFocus = (e) => {
    //    settail(true);
    //    if (okBtnPopupRef.current) {
    //     okBtnPopupRef.current.focus(); // Set focus to the modal
    // }
    //    if (fullContainerRef.current) {
    //     fullContainerRef.current.setAttribute("tabindex", "-1");
    // }
        };
    const funQrScannerSubmit = (code) => {
        console.log("Scanned QR:", code);
        dispatch(FetchPrintModeModalStatus({
            Type: "PRINT_MODE_MODAL_STATUS",
            PrintModeModalStatus: true
        }));
        goBack();
    };

    const funCancleQrScanner = () => {
        dispatch(FetchPrintModeModalStatus({
            Type: "PRINT_MODE_MODAL_STATUS",
            PrintModeModalStatus: true
        }));
        goBack();
    };

    return (
        <>
            {selectedprintMode === "SITA FLEX" ? (   
                    <LocationQrScanner
                        title="Scan or Upload QR"
                        onSubmit={funQrScannerSubmit}
                        onCancel={funCancleQrScanner}
                        submitText="Proceed"
                        cancelText="Close"
                        printer={sitaFlexPrinter}
                    />
                    ):(
                        <div>
                            {/* <LogoutModel trigger={triggerModal}> </LogoutModel> */}
                            <div class="full-container" 
                                            // ref={fullContainerRef}
                                >
                                <div class="printer-container card">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="printer-data">
                                                <div class="pTable-data-outer bagData">
                                                    <div class="printer-settings-modal">
                                                        {/* <div class="modal-header pb-0">
                                                            <h5 class="font-lg bold dark-text">Printer Settings</h5>
                                                            <button onClick={goBack} type="button" class="close" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div> */}

                                                        <div class="modal-body">
                                                            <div class="d-flex gap-5 row">
                                                                <div class="col-md-2  flex-column">
                                                                    <div class="font-md bold dark-text mb-2">Bag Tags</div>
                                                                    <div class="d-flex ">

                                                                        <select class="form-control bag-tags-textbox-left  custom-select" value={bagtagPrinter} onChange={e => fncSelectBagtagPrinter(e)} id="bagTagsSelect">
                                                                            <option id='Select the Printer' selected>Select the Printer</option>
                                                                            {
                                                                                lsprinters.length == 0 ? '' :
                                                                                lsprinters.map((printer) =>
                                                                                    <option id={printer.name}>
                                                                                        {printer.name}
                                                                                    </option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                        {/* <a data-bs-dismiss="modal" class="bag-tags-textbox-right btn-add btn btn-primary btn-animation d-flex w-10">
                                                                            <span class="font-md bold">...</span>
                                                                        </a> */}
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-3  flex-column">
                                                                    <div class="font-md bold dark-text mb-2" >Boarding Pass</div>
                                                                    <div class="d-flex ">

                                                                        <select class="form-control bag-tags-textbox-left custom-select" value={boardingPrinter} onChange={e => fncSelectBoardingPrinter(e)} id="boardingPassSelect">
                                                                            <option id='Select the Printer' selected>Select the Printer</option>
                                                                            {
                                                                                lsprinters.length == 0 ? '' :
                                                                                lsprinters.map((printer) =>
                                                                                    <option id={printer.name}>
                                                                                        {printer.name}
                                                                                    </option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                        {/* <a data-bs-dismiss="modal" class="bag-tags-textbox-right btn-add btn btn-primary btn-animation d-flex w-10">
                                                                            <span class="font-md bold">...</span>
                                                                        </a> */}
                                                                    </div>
                                                                </div>
                                                                <div class=" gap-3 mt-4 d-flex col-md-6">
                                                                    <button
                                                                            data-bs-toggle="modal"
                                                                            id='okbtnofperiferal'
                                                                            data-bs-target="#addNewSecurity"
                                                                            data-bs-dismiss="modal" class="btn-add btn btn-primary btn-animation d-flex px-6 SerachBtn"
                                                                            onClick={handleFocus} 
                                                                            
                                                                        >
                                                                        <span class="font-md bold" >ok</span>
                                                                    </button>
                                                                    <button    onClick={goBack} class="px-4 btn-cancel btn  btn-primary btn-animation d-flex SerachBtn">
                                                                        
                                                                        <span class="font-md bold">Cancel</span>
                                                                    </button>
                                                                    <button   onClick={resetPrintersOnlocalStorage} class="px-4 btn-cancel btn  btn-primary btn-animation d-flex SerachBtn ">
                                                                        
                                                                        <span class="font-md bold">Reset Printers</span>
                                                                    </button>
                                                                </div>
                                                                
                                                            </div>
                                                            <div class="peripheral-devices mt-4">
                                                                <h5 class="font-lg bold dark-text">Peripheral Devices</h5>
                                                                <div class="table-responsive">
                                                                    <table class="table ">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Device Name</th>
                                                                                <th>Device Type</th>
                                                                                <th>Device Status</th>
                                                                                <th>Preload status</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                lsprinters.length ? lsprinters.map((item, i) =>
                                                                                // printer.length ? printer.map((item, i) =>
                                                                                // <tbody>
                                                                                    <tr>
                                                                                        <td><span class="status-indicator offline"></span> {item.name}</td>
                                                                                        <td> {item.address ? 'Bluetooth' : 'USB'} </td>
                                                                                        <td>{item.connected ? 'Available' : 'Not available'}</td>
                                                                                        <td></td>
                                                                                    </tr>
                                                                                // </tbody>
                                                                                ) : <p> No printer found</p>
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div>
                                                            {/* <div class=" gap-3 mt-4 d-flex ">
                                                                <button
                                                                        data-bs-toggle="modal"
                                                                        id='okbtnofperiferal'
                                                                        data-bs-target="#addNewSecurity"
                                                                        data-bs-dismiss="modal" class="btn-add btn btn-primary btn-animation d-flex px-6 SerachBtn"
                                                                        onClick={handleFocus} 
                                                                        
                                                                    >
                                                                    <span class="font-md bold" >ok</span>
                                                                </button>
                                                                <button    onClick={goBack} class="px-4 btn-cancel btn  btn-primary btn-animation d-flex SerachBtn">
                                                                    
                                                                    <span class="font-md bold">Cancel</span>
                                                                </button>
                                                                <button   onClick={resetPrintersOnlocalStorage} class="px-4 btn-cancel btn  btn-primary btn-animation d-flex SerachBtn ">
                                                                    
                                                                    <span class="font-md bold">Reset Printers</span>
                                                                </button>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* new modal */}
                            <div
                                class="modal fade"
                                id="addNewSecurity"
                                tabindex="-1"
                                aria-labelledby="staticBackdropLabel"
                                aria-hidden="true"
                                data-bs-backdrop="static"
                                data-dismiss="modal"
                                data-toggle="modal"
                            >

                                <div class="modal-dialog modal-dialog-centered security-modal seat-modal">
                                    <div class="modal-content px-5"               
                                    >
                                        <div class="bagDetails">
                                            <div class="">
                                                <div
                                                    class="d-flex mb-3 justify-content-between align-items-center"
                                                >
                                                    <div class="heading-content">
                                                        <h4 class=" font-lg bold dark-text mb-1">
                                                            Selected Printers
                                </h4>
                                                    </div>
                                                </div>
                                                <div class="bagform">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class=" mb-3">
                                                                <p class="font-md bold dark-text mb-1">Boarding Pass Printer</p>
                                                                <p class="font-md  grey-text mb-1">{boardingPrinter === 'Select the Printer' ? 'No Printer selected' : boardingPrinter}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class=" mb-3">
                                                                <p class="font-md bold dark-text mb-1">Bag Tags Printer</p>
                                                                <p class="font-md  grey-text mb-1">{bagtagPrinter === 'Select the Printer' ? 'No Printer selected' : bagtagPrinter}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class=" mb-3">
                                                                <p class="font-md  grey-text mb-1">Do you want to proceed further?</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="btn-container d-flex">
                                                    <button 
                                                    ref={okBtnPopupRef}
                                                    // tabIndex={0}
                                                        data-bs-dismiss="modal"
                                                        class="btn-add btn btn-primary btn-animation d-flex justify-content-center SerachBtn"
                                                        onClick={fncSetPrintersToLocalStorage}
                                                    >
                                                        <span class="font-md bold ">Yes</span>
                                                    </button>
                                                    <button
                                                                                        // tabIndex={0}

                                                        data-bs-dismiss="modal"
                                                        class="btn-cancel btn btn-primary btn-animation d-flex justify-content-center SerachBtn"
                                                    >
                                                        <span class="font-md bold">No</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
        </>
    )
}

export default PeripheralDevices;